import script from "./AllPortfoliosSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AllPortfoliosSummary.vue?vue&type=script&setup=true&lang=js"

import "./AllPortfoliosSummary.vue?vue&type=style&index=0&id=58a0c672&lang=scss"

const __exports__ = script;

export default __exports__